export default "__VITE_ASSET__DzNE9QO$__$_?url__"